var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocalAndRegionalNews = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Newspaper-Fold--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Newspaper Fold Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 4.5h3.25S10 4.5 10 5.75v4.75s0 1.25 -1.25 1.25H5.5s-1.25 0 -1.25 -1.25V5.75s0 -1.25 1.25 -1.25",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 10a3 3 0 0 0 -3 -3h-2V2.5a2 2 0 0 0 -2 -2H2a2 2 0 0 0 -2 2V20a3.5 3.5 0 0 0 3.5 3.5h17A3.5 3.5 0 0 0 24 20ZM3.5 21.5A1.5 1.5 0 0 1 2 20V3a0.5 0.5 0 0 1 0.5 -0.5h14a0.5 0.5 0 0 1 0.5 0.5v17a3.51 3.51 0 0 0 0.11 0.87 0.5 0.5 0 0 1 -0.09 0.44 0.49 0.49 0 0 1 -0.39 0.19ZM22 20a1.5 1.5 0 0 1 -3 0V9.5a0.5 0.5 0 0 1 0.5 -0.5H21a1 1 0 0 1 1 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 6.05h2s0.75 0 0.75 0.75v0.5s0 0.75 -0.75 0.75h-2s-0.75 0 -0.75 -0.75v-0.5s0 -0.75 0.75 -0.75",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 10.05h2s0.75 0 0.75 0.75v0.5s0 0.75 -0.75 0.75h-2s-0.75 0 -0.75 -0.75v-0.5s0 -0.75 0.75 -0.75",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75 14.05h10s0.75 0 0.75 0.75v0.5s0 0.75 -0.75 0.75h-10s-0.75 0 -0.75 -0.75v-0.5s0 -0.75 0.75 -0.75",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75 18.05h7.5s0.75 0 0.75 0.75v0.5s0 0.75 -0.75 0.75h-7.5s-0.75 0 -0.75 -0.75v-0.5s0 -0.75 0.75 -0.75",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocalAndRegionalNews);
export default ForwardRef;